import { createI18n } from 'vue-i18n';
import langEn from './languages/en.json';
import langEs from './languages/es.json';

const i18n = createI18n({
  locale: 'es',
  allowComposition: true,
  fallbackLocale: 'en',
  messages: {
    en: langEn,
    es: langEs
  }
});

export default i18n;